export type ErrorCode =
  | 'INTERNAL_SERVER_ERROR'
  | 'INTERNAL_CLIENT_ERROR'
  | 'NOT_FOUND'
  | 'CONSISTENCY_VIOLATION'
  | 'CONSTRAINT_VIOLATION'
  | 'UNAUTHORIZED'
  | 'INVALID_USER'
  | 'UNAUTHORIZED_SCOPE'
  | 'RETRY_NEEDED'
  | 'BUSINESS_ERROR'

export const getErrorCode = (error: unknown): ErrorCode | undefined => {
  if (error === null || typeof error !== 'object' || !('code' in error)) {
    return undefined
  }
  return (error as { code?: ErrorCode }).code
}
